import React from 'react'
import clsx from 'classnames'
import type { Profile } from 'api/api.types'
import unauthenticatedIcon from 'assets/avatar-placeholder-empty.svg'
import avatarPlaceholder from 'assets/avatar-placeholder-f.png'
import { ImageLoader } from 'components/Utility/ImageLoader/ImageLoader'
import styles from './Avatar.module.scss'

type AvatarProps = {
  user: Profile | null,
  className?: string,
}

export const Avatar: React.FC<AvatarProps> = (props) => {
  const { user, className } = props
  let imageSrc = unauthenticatedIcon
  if (user) {
    imageSrc = user.avatar || avatarPlaceholder
  }
  return <div className={clsx([styles.container, className])}>
    <ImageLoader src={imageSrc} className={styles.image} title={'Профиль пользователя'} alt={'Аватар'} />
  </div>
}
